module.exports = __webpack_public_path__ + "fonts/DidotLH-Italic.d665f951.woff2";